import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=8892161e&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=js&"
export * from "./DetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=8892161e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8892161e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/DetailHeader.vue
// module id = 660
// module chunks = 0